import { Services } from 'shared/domain/messages/message';
import type {
  OrganizationCreateRequest,
  OrganizationEditRequest,
} from 'shared/domain/messages/organization/eventMessages';
import { broadcastAllOrganizations } from 'serviceWorker/broadcasts/organization/all';
import * as organizations from 'serviceWorker/db/organizations/organizations';
import * as organizationsService from 'serviceWorker/db/organizations/organizationsService';
import { debugLog } from 'shared/logger/debugLog';
import { createSyncedEntity } from '../factories/createSyncedEntity';
import { organizationSaver } from './addOrganization';
import { organizationEditor } from './editOrganization';
import { fetchOrganizations } from './fetchOrganizations';
import { organizationContract } from 'shared/domain/organization/organizationContract';

/**
 * Organizations are not project data: their pull does not need a selected
 * project. Every read syncs them, so the stored ones stay readable while the
 * list downloads again and replaces them.
 */
export const organizationsSync = createSyncedEntity({
  entityName: Services.ORGANIZATIONS,
  contract: organizationContract,
  repository: organizations,
  service: organizationsService,
  fetch: fetchOrganizations,
  publishCollection: broadcastAllOrganizations,
  requiredConfig: ['locale', 'api'],
  keepStoredWhileDownloading: true,
});

/**
 * Resolves once the change is in the HTTP queue and rejects only when it could
 * not be queued. The server's answer follows as an event (`createdEntity`,
 * `updatedEntity`, `failUploadedEntity`) with the change's `uniqueId`.
 */
export function handleCreateOrganization(
  detail: OrganizationCreateRequest
): Promise<void> {
  debugLog('addOrganization', detail);
  return organizationSaver.execute(detail.organizationCreateModel, detail.uniqueId);
}

export function handleEditOrganization(
  detail: OrganizationEditRequest
): Promise<void> {
  debugLog('editOrganization', detail);
  return organizationEditor.execute(detail.organizationEditModel, detail.uniqueId);
}
